import React from "react";
import {
    RadioGroup,
    Grid,
    TextField,
    Button,
    withStyles,
    FormControlLabel,
    Radio,
    MenuItem,
    FormGroup,
    Checkbox,
    InputLabel,
    Select,
    Input,
    FormControl
  } from "material-ui";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Tooltip from "material-ui/Tooltip";
import Title from "../../ui/title";
import Content from "../../ui/content";
import styles from "./styles";
import ConfirmDialog from "../../common/dialog/confirm";
import { withRouter } from "react-router-dom";
import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { validateFormData } from "../../../common/formtool";
import { ToInt, ToReal, ToDuration } from "../../../common/datatypetool";
import { feetToMetersDecimal, metersToFeetDecimal } from "../../../common/utils";
import { element } from "prop-types";
import { translate } from "exif-orientation-image";
import { FiberQualificationEnum } from "../../job/newsignaltekqt/fiberqualification/fiberqualificationenums"

class FiberLength extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fiberLengthSettingType: "",
      isChanged: false,
      showConfirmBack: false,
      refractiveIndex: 1.4930,
      defaultRefractiveIndex: 1.4930,
      noLimit: false,
      customLimit: false,
      errors: {},
      showRestoreConfirm: false,
      isFiberLengthUpdated: false,
      fiberLengthInitialised: false,
      testConfig: this.mapEnumValue(0, "testconfig")
    };
  }

  mapEnumValue = (key, type) => {
    switch (type.toLowerCase()) {
      case "testconfig": {
        return FiberQualificationEnum.TestConfig.filter(
          enumType => enumType.key === parseInt(key)
        );
      }

    }
    return [];
  };
  
  toFixed = (e, numberOfDigit, newErrors) => {
    let value = ToReal(e.target.value);
    value = value.split(".");
    if (value.length > 2) {
      this.setState({ errors: { [e.target.name]: {} } });
    } else if (value.length === 1) {
      this.setState({
        [e.target.name]: value[0],
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    } else {
      if (value[1].length > numberOfDigit) {
        e.preventDefault();
      } else {
        this.setState({
          [e.target.name]: ToReal(e.target.value),
          isChanged: true,
          isRestore: false,
          errors: newErrors
        });
      }
    }
  };

  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };

  onBackYesClick = () => {
    this.setState({
      showConfirmBack: false
    });
    this.onFiberLengthSave();
  };

  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };

  translateElements = (elements) => {
    const { translate } = this.props;
    if (elements !== undefined) {
      elements.forEach(e => {
        e.value = translate(e.value);
      });
    }
    return elements;
  };

  

  onChange = e => {
    let validateErrors = this.state.errors;
    const { translate } = this.props;
    switch (e.target.name) {
        case "refractiveIndex":
          delete validateErrors[e.target.name];
          this.toFixed(e, 4, validateErrors);
          this.setState({
            isChanged: true,
            refractiveIndex: ToReal(e.target.value)
          });
          break;
        case "testconfig":
          this.setState({
            testConfig: this.mapEnumValue(e.target.value, "testconfig"),
            isChanged: true,
            isRestore: false
          });
          break;
    }
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true
      });
    }
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };

  onRestoreConfirm = () => {
    this.updateFiberLengthLoss(this.props.fiberLength);
    this.setState({
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };

  renderValue = selectedValue => {
    return selectedValue && selectedValue.length && selectedValue[0].value;
  };

  renderTranslatedValue = (selectedValue, translate) => {
    return selectedValue && selectedValue.length && translate(selectedValue[0].value);
  };


  onFiberLengthSave = () => {
    const {
      refractiveIndex,
      testConfig
    } = this.state;
    const { translate, isTestEdit } = this.props;

    let validationObj = {
      refractiveIndex: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 1.3000,
          maxValue: 1.5500,
          message: translate("formfield_error_general_required"),
        },
      }
    };

    let errors = validateFormData(
      { refractiveIndex },
      validationObj
    );


    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      
      const payload = {
        refractiveindex: parseFloat(refractiveIndex),
        singlefiber: parseInt(testConfig[0].key) === 1,
        devicetype: "navitek" 
      };
      if (isTestEdit) {
        this.props.updateFiberLengthLoss(this.props.selectedTest, payload);
        this.props.handleClose();
      } else {
        this.props.updateFiberLengthLoss(payload);
      }
      if (this.state.isRestore) {
        this.props.deleteDefaultSubtests(this.props.selectedTest);
      }
      this.setState({
        isChanged: false,
        errors: {}
      });
    }
  };

  render() {
    const {
      translate,
      classes,
      isTestEdit,
      testEdit,
      fiberlengthdetails,
      modified
    } = this.props;
    const {
      refractiveIndex,
      isChanged,
      errors,
      testConfig,
      isRestore
    } = this.state;

    return (
      <div display="flex" flexdirection="row" p={1} m={1}  style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={translate("fiberlength_setup")}
          />
        )}
        <Content translate={translate}>
                <Grid item xs={3}>
                <TextField
                    className={classes.textField}
                    error={errors.refractiveIndex}
                    label={translate("fiber_refractiveindex")}
                    name="refractiveIndex"
                    margin="normal"
                    value={refractiveIndex}
                    onChange={this.onChange}
                    disabled={false}
                    fullWidth
                    helperText={
                        errors.refractiveIndex
                        ? translate("subtest_number_range", {
                            start: 1.3000,
                            end: 1.5500
                        })
                        : ""
                    }
                />
                </Grid>
                <div style={{ height: "20px" }}></div>
                <Grid item xs={6}>
                  {/* TEST CONFIGURATION */}
                  <FormControl
                    className={classes.textField}
                    margin="normal"
                  >
                    <InputLabel id="testconfig">{translate("fibre_test_configuration")}</InputLabel>
                    <Select
                      labelId="testconfig"
                      name="testconfig"
                      renderValue={() => this.renderTranslatedValue(testConfig, translate)}
                      onChange={this.onChange}
                      input={
                        <Input value={() => this.renderTranslatedValue(testConfig, translate)} />
                      }
                      style={{width: "50%"}}
                    >
                    {FiberQualificationEnum.TestConfig.map(enumType => {
                        return (
                            <MenuItem key={enumType.value} value={enumType.key}>
                                {translate(enumType.value)}
                            </MenuItem>
                        );
                    })}
                    
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid container>
                    <Grid item xs={8}>
                    </Grid>
                    <Grid item xs={4}></Grid>
                </Grid>
                  <br />
                  {!isTestEdit && (
                    <div align="left">
                      <Button
                        className={classes.saveTarget}
                        disabled={!isChanged}
                        color="accent"
                        raised
                        mini
                        onClick={this.onFiberLengthSave}
                      >
                        {translate("sub_set_ping_save_target")}
                      </Button>
                    </div>
                  )}
                <Grid item xs={isTestEdit ? 0 : 2}></Grid>
          {!isTestEdit && (
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ping_delete_confirm_title", {
                name: translate("fiberlengthloss")
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              cancelText={translate("general_cancel")}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.state.showRestoreConfirm}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("restore_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onRestoreConfirm}
              onCancel={this.hideRestoreConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.props.showTestCreationCancelConfirmation}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("st_test_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.props.onTestCreationCancelConfirm}
              onCancel={this.props.hideTestCreationCancelConfirm}
            />
          )}
        </Content>
        {isTestEdit && testConfig && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "inline-block", marginLeft: "20px" }}>
                {fiberlengthdetails && !testEdit ? (
                  <Button
                    className={classes.restoreButton}
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : testEdit && modified ? (
                  <Button
                    className={classes.restoreButton}
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : null}
              </div>
              <div style={{ display: "inline-block", marginRight: "100px" }}>
                <Button
                  className={classes.saveTarget}
                  disabled={!isChanged}
                  color="accent"
                  raised
                  onClick={() => this.onFiberLengthSave()}
                >
                  {translate("general_continue")}
                </Button>
              </div>
            </div>
          )}
      </div>
    );
  }

  // component life cycles 
  componentWillMount() {
    const { getFiberLength } = this.props;
    getFiberLength();
  }

  componentWillReceiveProps(nextProps) {
    const { fiberLengthInitialised } = this.state
    const { fiberLengthLoss, fiberlengthdetails, isTestEdit } = nextProps;
    if (isTestEdit && !fiberlengthdetails) {
      if (fiberLengthLoss && this.props.fiberLengthLoss != fiberLengthLoss && !fiberLengthInitialised) {
        this.setState({ fiberLengthInitialised: true }, this.updateFiberLengthLoss(fiberLengthLoss));
      }
    } else if (isTestEdit && fiberlengthdetails) {
      if (
        (fiberlengthdetails && this.props.fiberlengthdetails != fiberlengthdetails) ||
        !this.state.isFiberLengthUpdated
      ) {
        this.updateFiberLengthLoss(fiberlengthdetails);
        this.setState({ isFiberLengthUpdated: true });
      }
    } else {
      if (fiberLengthLoss && this.props.fiberLengthLoss != fiberLengthLoss) {
        this.updateFiberLengthLoss(fiberLengthLoss);
      }
    }
  }


  componentDidMount() {
    window.scrollTo(0, 0)
  }

  updateFiberLengthLoss = (fiberLengthLoss) => {
    this.setState({
      testConfig: this.mapEnumValue(
        fiberLengthLoss.singlefiber == true ? 1 : 0,
        "testconfig"
      ),  
      refractiveIndex: parseFloat(fiberLengthLoss.refractiveindex),
    });
  };
}

export default withRouter(withStyles(styles)(FiberLength));
